export const MINI_CARD_WIDTH = 80;
export const MINI_CARD_UPPER_SECTION_HEIGHT = 34;
export const MINI_CARD_HEIGHT = 56;
export const MINI_CARD_TITLE_SPACING_TEXT_FILLER = `\u00A0\u00A0\u00A0\u00A0`;
